const money = new Intl.NumberFormat(window.Shopify.country, {
  style: 'currency',
  currency: window.Shopify.currency.active
});

// Override the ReCharge bundling widget's default add-to-cart behavior
// (which redirects to /cart). Instead, open the theme's native cart-drawer.
// See: https://docs.getrecharge.com/docs/bundling-widget-events
window.RechargeBundle = {
  onAddToCart: () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true },
    }));
  },
};

document.addEventListener('DOMContentLoaded', (e) => {
  if (!customElements.get('rb-modal')) {
    class RechargeModal extends ModalComponent {
      constructor() {
        super();

        this.recharge = {
          products: [],
          inputs: [],
          upsell: {
            buttons: []
          }
        }

        document.addEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
        document.addEventListener('recharge:progress', this.onProgressChange.bind(this));
        document.addEventListener("recharge:variant", this.onVariantChange.bind(this));
        document.addEventListener("recharge:filter", this.onFilterChange.bind(this));
        document.addEventListener("recharge:modal:open", this.onOpenEvent.bind(this));
        document.addEventListener("recharge:modal:close", this.onCloseEvent.bind(this));
        document.addEventListener("recharge:delivery:update", this.onDeliveryUpdate.bind(this));
        document.addEventListener("recharge:images", this.onImagesChange.bind(this));
      }

      isOpen() {
        return this.hasAttribute('open');
      }

      disconnectedCallback() {
        document.removeEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
        document.removeEventListener('recharge:progress', this.onProgressChange.bind(this));
        document.removeEventListener("recharge:variant", this.onVariantChange.bind(this));
        document.removeEventListener("recharge:filter", this.onFilterChange.bind(this));
        document.removeEventListener("recharge:modal:open", this.onOpenEvent.bind(this));
        document.removeEventListener("recharge:modal:close", this.onCloseEvent.bind(this));
      }

      onRechargeReady() {
        setTimeout(() => {
          this.recharge.inputs = Array.from(document.querySelectorAll('.rb-item-actions input'));
          this.recharge.inputs.forEach(input => input.addEventListener('change', this.changeCookies.bind(this)));
          
          this.recharge.buttons = document.querySelectorAll('.rb-item-actions button');
          this.recharge.buttons.forEach(button => button.addEventListener('click', this.changeCookies.bind(this)));

          this.recharge.products = Array.from(document.querySelectorAll('.rb-item'))

          this.recharge.upsell.buttons = Array.from(this.querySelectorAll('[data-upsell] button'))
          this.recharge.upsell.buttons.forEach(button => button.addEventListener('click', this.changeVariant.bind(this)));

          const submits = this.querySelectorAll('button[type="submit"]');
          submits.forEach(button => button.addEventListener('click', this.onSubmit.bind(this)));

          this.recharge.frequencySelect = this.querySelector('[data-modal-frequency]');
          if(this.recharge.frequencySelect) {
            this.recharge.frequencySelect.addEventListener('change', this.onFrequencyChange.bind(this));
          }
          this.syncFrequencyFromConfiguration();
        }, 100);
      }

      onFrequencyChange(event) {
        const select = event.currentTarget;
        const option = select.options[select.selectedIndex];
        const label = option && (option.dataset.label || option.innerText.trim());
        if(!label) return;

        document.dispatchEvent(new CustomEvent('recharge:delivery:update', {
          detail: label
        }));
      }

      onDeliveryUpdate(event) {
        const label = event && event.detail;
        const select = this.recharge.frequencySelect;
        if(!label || !select) return;

        const options = Array.from(select.options);
        const match = options.find(option => (option.dataset.label || option.innerText.trim()) === label);
        if(match && select.value !== match.value) {
          select.value = match.value;
        }
      }

      syncFrequencyFromConfiguration() {
        const source = document.querySelector('#rb-configuration-selling_plan');
        if(!source) return;
        const option = source.options[source.selectedIndex];
        if(!option) return;
        this.onDeliveryUpdate({ detail: option.innerText.trim() });
      }

      onProgressChange(event) {
        const { full, prices, totals } = event.detail;

        //Only auto-open on the false → true transition. Recharge keeps firing
        //full:true on every subsequent progress event (price refresh, filter
        //change, post-ATC re-renders), which previously re-opened the modal
        //behind the cart drawer.
        if(full === true && this._lastFull !== true) {
          this._lastFull = full;
          this.show();
          //`totals` holds both prices regardless of the Abo slider, so the
          //hack is only needed when no meal price data is available.
          if(totals) {
            this.renderPrices(totals);
          } else {
            this.refreshPricesWithAboHack(prices);
          }
          return;
        }

        if(full !== true) {
          this._aboHackDone = false;
        }

        this._lastFull = full;

        //`totals` is the cart-accurate sum of the picked meals.
        const rendered = totals || prices;
        if(rendered) {
          this.renderPrices(rendered);
        }
      }

      renderPrices(prices) {
        this.querySelectorAll('[data-price]').forEach(element => {
          element.innerText = prices.price ? money.format(prices.price / 100) : '';
        });
        this.querySelectorAll('[data-compare-at-price]').forEach(element => {
          element.innerText = prices.compare_at_price ? money.format(prices.compare_at_price / 100) : '';
        });
      }

      //If Abo is off when the modal opens, the recharge widget reports
      //compare_at_price = 0. Briefly toggle Abo on to read the real
      //compare_at_price, then toggle back. Same trick as the legacy
      //as-pm0004 popup. Only runs when the modal opens, so the slider
      //flicker is hidden behind the popup.
      refreshPricesWithAboHack(currentPrices) {
        const aboLabel = document.querySelector('rb-delivery .rb-switch');
        const aboInput = document.querySelector('rb-delivery .rb-switch input[type="checkbox"]');
        const rbAmount = document.querySelector('rb-amount');

        //Abo on or no slider → just render the prices we already have.
        if(!aboLabel || !aboInput || !rbAmount || aboInput.checked) {
          if(currentPrices) this.renderPrices(currentPrices);
          return;
        }

        this._aboHackDone = true;
        window._rechargeAboTogglePending = true;
        aboLabel.click();
        setTimeout(() => {
          const prices = rbAmount.getPrices();
          aboLabel.click();
          setTimeout(() => {
            window._rechargeAboTogglePending = false;
            this.renderPrices(prices);
          }, 50);
        }, 50);
      }

      onFilterChange() {
        // After filtering the ReCharge widget re-renders .rb-item-actions nodes,
        // so we need to re-attach changeCookies listeners to the new DOM nodes.
        setTimeout(() => this.onRechargeReady(), 100);
      }

      onVariantChange(event) {
        if(!event.detail || !event.detail.id || !event.detail.title) {
          return console.error('onVariantChange', 'no id');
        }

        //Grab Id
        const { id, title }  = event.detail;

        //Hide all other upsells
        const upsells = Array.from(this.querySelectorAll('[data-upsell]'));
        upsells.forEach(upsell => upsell.setAttribute('hidden', true));

        const upsell = upsells.find(upsell => upsell.dataset.variantId === id);
        if(upsell) {
          upsell.removeAttribute('hidden');
        }

        const headline = this.querySelector('h4[data-label]');
        if(headline) {
          headline.innerText = headline.dataset.label.replace('{{ title }}', title)
        }

        //Add back Listeners
        this.onRechargeReady();
      }

      onSubmit() {
        this.onCloseEvent();

        const button = document.querySelector('.rb-amount button');
        button.click();
      }

      onOpenEvent() {
        this.show();
      }

      onCloseEvent() {
        this.hide();
      }

      changeCookies(event) {
        const parent = event.target.closest('.rb-item');
        if(!parent) {
          return console.error('RechargeModal', 'no item', parent)
        }

        //Recharge patches the input value asynchronously, so reading it on
        //the click itself always saw the quantity from before it.
        setTimeout(() => this.storeProduct(parent), 0);
      }

      storeProduct(parent) {
        const input = parent.querySelector('.rb-input')
        const image = parent.querySelector('img');

        if(!input || !image) {
          return console.error('RechargeModal', 'missing', 'input, title, image');
        }

        let products = Shopify.LocalStorage.get(cookieProducts) || {};

        //Slugify name
        const name = Shopify.Slugify(input.name);
        const quantity = parseInt(input.value);

        if(quantity) {
          products[name] = {
            //Prevent weird wordings
            name: encodeURIComponent(input.name),
            image: image.src ?? '',
            quantity: parseInt(quantity),
          }
        } else {
          delete products[name];
        }

        //Set the cookies
        Shopify.LocalStorage.set(cookieProducts, products);

        //Update Layout
        this.changeProducts(products);
      }

      changeVariant(event) {
        const id = event.target.dataset.id;
        if(!id) {
          return;
        }

        const variant = document.querySelector(`rb-button[id="${id}"]`);
        variant.click();

        //Close Modal
        this.onCloseEvent();
      }

      onImagesChange() {
        this.changeProducts(Shopify.LocalStorage.get(cookieProducts) || {});
      }

      //The artwork depends on the selected box size (see recharge-products.js),
      //so resolve it from the current item list instead of trusting the src
      //that changeCookies froze into storage when the meal was picked.
      itemImage(title) {
        const images = Array.from(document.querySelectorAll('.rb-item-img .rb-aspect-ratio img'));
        const match = images.find(image => image.getAttribute('alt') === title);

        return match && match.getAttribute('src');
      }

      changeProducts(products) {
        const product = this.querySelector('[data-products]');
        product.innerHTML = Object.values(products).map(product => {
          const name = decodeURIComponent(product.name);
          const image = this.itemImage(name) || product.image;
          return `<div class="rb-modal-product" data-title="${name}">
              <img src="${image}" alt="Meal ${name}">
              <span>${product.quantity}x ${name}</span>
          </div>`;
        }).join('')
      }

    }
    customElements.define('rb-modal', RechargeModal);
  }
});
